module.exports = __webpack_public_path__ + "img/root1.9d0c8706.png";